/**
 * @flow
 * @relayHash 5f378f9ca4da933346ff30e2be689605
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CorporateActionList_viewer$ref = any;
export type CorporateActionListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  symbol?: ?string,
  currency?: ?string,
  ibConIdIn?: ?$ReadOnlyArray<?string>,
  reportDate?: ?any,
  processedAt_Isnull?: ?boolean,
  ignored?: ?boolean,
  performanceProcessed?: ?boolean,
|};
export type CorporateActionListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CorporateActionList_viewer$ref
  |}
|};
export type CorporateActionListQuery = {|
  variables: CorporateActionListQueryVariables,
  response: CorporateActionListQueryResponse,
|};
*/


/*
query CorporateActionListQuery(
  $first: Int
  $offset: Int
  $search: String
  $symbol: String
  $currency: String
  $ibConIdIn: [String]
  $reportDate: Date
  $processedAt_Isnull: Boolean
  $ignored: Boolean
  $performanceProcessed: Boolean
) {
  viewer {
    ...CorporateActionList_viewer_4x8CkA
    id
  }
}

fragment CorporateActionList_viewer_4x8CkA on Query {
  ibCorporateActions(first: $first, offset: $offset, search: $search, symbol: $symbol, currency: $currency, ibConIdIn: $ibConIdIn, reportDate: $reportDate, processedAt_Isnull: $processedAt_Isnull, ignored: $ignored, performanceProcessed: $performanceProcessed) {
    edges {
      node {
        id
        ignored
        processedAt
        processedBy {
          username
          fullName
          id
        }
        group {
          id
          description
        }
        transactionId
        ibConId
        currency
        description
        isin
        symbol
        transactionDatetime
        reportDate
        quantity
        proceeds
        type
        contract {
          id
          symbol
          currency
          ibConId
        }
        notes {
          id
        }
        brokeractivityPtr {
          id
          group {
            id
            description
          }
          responsiblecontract {
            contract {
              symbol
              id
              ibConId
              name
              currency
              exchange {
                name
                symbol
                id
              }
            }
            id
          }
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  name
                  id
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      portfolio {
                        id
                      }
                      contract {
                        id
                        symbol
                      }
                      quantity
                      id
                    }
                  }
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      currency
                      quantity
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    count
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "symbol",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "currency",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ibConIdIn",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reportDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "processedAt_Isnull",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ignored",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "performanceProcessed",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "currency",
    "variableName": "currency"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ibConIdIn",
    "variableName": "ibConIdIn"
  },
  {
    "kind": "Variable",
    "name": "ignored",
    "variableName": "ignored"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "performanceProcessed",
    "variableName": "performanceProcessed"
  },
  {
    "kind": "Variable",
    "name": "processedAt_Isnull",
    "variableName": "processedAt_Isnull"
  },
  {
    "kind": "Variable",
    "name": "reportDate",
    "variableName": "reportDate"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "symbol",
    "variableName": "symbol"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v9 = [
  (v2/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CorporateActionListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CorporateActionList_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CorporateActionListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "ibCorporateActions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "IBCorporateActionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCorporateActionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "IBCorporateActionNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ignored",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "processedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "processedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "username",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transactionId",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transactionDatetime",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reportDate",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "proceeds",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "notes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NotesNode",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivityPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "responsiblecontract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ResponsibleContractNode",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "contract",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ContractNode",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  (v10/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "exchange",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExchangeNode",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v7/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokeractivitytransactionSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "account",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AccountNode",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v2/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncontractdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "portfolio",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioNode",
                                                    "plural": false,
                                                    "selections": (v9/*: any*/)
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "contract",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ContractNode",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      (v7/*: any*/)
                                                    ]
                                                  },
                                                  (v8/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncashdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v8/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreviousPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CorporateActionListQuery",
    "id": null,
    "text": "query CorporateActionListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $symbol: String\n  $currency: String\n  $ibConIdIn: [String]\n  $reportDate: Date\n  $processedAt_Isnull: Boolean\n  $ignored: Boolean\n  $performanceProcessed: Boolean\n) {\n  viewer {\n    ...CorporateActionList_viewer_4x8CkA\n    id\n  }\n}\n\nfragment CorporateActionList_viewer_4x8CkA on Query {\n  ibCorporateActions(first: $first, offset: $offset, search: $search, symbol: $symbol, currency: $currency, ibConIdIn: $ibConIdIn, reportDate: $reportDate, processedAt_Isnull: $processedAt_Isnull, ignored: $ignored, performanceProcessed: $performanceProcessed) {\n    edges {\n      node {\n        id\n        ignored\n        processedAt\n        processedBy {\n          username\n          fullName\n          id\n        }\n        group {\n          id\n          description\n        }\n        transactionId\n        ibConId\n        currency\n        description\n        isin\n        symbol\n        transactionDatetime\n        reportDate\n        quantity\n        proceeds\n        type\n        contract {\n          id\n          symbol\n          currency\n          ibConId\n        }\n        notes {\n          id\n        }\n        brokeractivityPtr {\n          id\n          group {\n            id\n            description\n          }\n          responsiblecontract {\n            contract {\n              symbol\n              id\n              ibConId\n              name\n              currency\n              exchange {\n                name\n                symbol\n                id\n              }\n            }\n            id\n          }\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  name\n                  id\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                        symbol\n                      }\n                      quantity\n                      id\n                    }\n                  }\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      currency\n                      quantity\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    count\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ce6d56a9548fc56a2c8c564213e10083';
module.exports = node;
